import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';

export type breadcrumb = {
  label: string;
  route: string;
  queryParams?: unknown;
};

@Component({
  selector: 'am-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent {
  constructor(private router: Router) {
    this.breadcrumbs = router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      startWith(router.routerState.snapshot),
      map(() => {
        const segments = router.url.split('/').slice(1);
        return segments.map((segment, i) => ({
          label: segment.replace(/-/g, ' '),
          route: `/` + segments.slice(0, i + 1).join('/'),
        }));
      })
    );
  }

  breadcrumbs: Observable<breadcrumb[]>;
}
